import { useEffect, useState } from "react";
import { LinearProgress, MenuItem, Paper, Select, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function MenusList({ data, loading, instanceSelected, selectInstance }) {
  const { t } = useTranslation();
  const mdMQ = useMediaQuery(theme => theme.breakpoints.up('md'));
  const [options, setOptions] = useState(null)

  useEffect(() => {
    if (data !== null && data !== undefined) {
      let options = []
      data.forEach(menu => {
        ///suc.menus.forEach(menu => {
        options.push({ _id: menu._id, name: menu.name/* , branch_office_name: suc.name */ })
        //})
      });
      setOptions(options)
    }
  }, [data])

  const handleChange = (event) => selectInstance(event.target.value)

  return (
    <Paper sx={{ padding: 0.5 }}>
      {(data !== null && options !== null && !loading) ?
        <div style={{ display: "grid", gridTemplateColumns: mdMQ ? "1fr 1fr" : "1fr", gap: 8, backgroundColor: "#ffffff", zIndex: 2, padding: 4 }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body1">{t('builder_page_instructions')}</Typography>
          </div>
          <Select fullWidth 
            size="small" 
            margin="dense" 
            id="grouped-select"
            defaultValue={''}  
            onChange={handleChange} >
            <MenuItem value={''} selected disabled> <em>{t('builder_page_menu_select_label')}</em> </MenuItem>
            {options.map((opt, j) => (
              <MenuItem key={`${opt._id}-${j}`} role="option" value={opt._id}>
                {opt.name}{/* &nbsp;<span style={{ fontSize: 12 }}>({opt.branch_office_name})</span> */}
              </MenuItem>
            ))}
          </Select>
        </div> : <div style={{ textAlign: "center" }} > <LinearProgress /> </div>}
    </Paper>
  )
}